import { render, staticRenderFns } from "./Forbid.vue?vue&type=template&id=e52da544&scoped=true&"
import script from "./Forbid.vue?vue&type=script&lang=ts&"
export * from "./Forbid.vue?vue&type=script&lang=ts&"
import style0 from "./Forbid.vue?vue&type=style&index=0&id=e52da544&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@rakete/cli-plugin-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52da544",
  null
  
)

export default component.exports